<template>
    <PainelGrafico
        titulo="OTIF Geral"
        v-model:aberto="mostrarGrafico"
        :desabilitado="true"
        :motivo-indisponivel="motivoIndisponivel"
        :carregando="false"
        :vazio="false"
    >
        <template #info>
            <v-menu location="end">
                <template v-slot:activator="{ props }">
                    <i v-bind="props" class="bi bi-info-circle" title="Sobre o indicador"></i>
                </template>
                <v-card min-width="100" style="max-width: 24rem; padding: 1rem">
                    <div>
                        <b>Fórmula:</b> Pedidos no prazo e completos ÷ total avaliados × 100.<br>
                        <b>Polaridade:</b> Quanto maior, melhor (meta {{ meta }}%).<br>
                        <b>Fonte:</b> Indisponível — depende do componente In Full.<br>
                        <b>Descrição:</b> Percentual OTIF no período. Será habilitado quando houver dados de completude.
                    </div>
                </v-card>
            </v-menu>
        </template>
    </PainelGrafico>
</template>

<script>
import PainelGrafico from '@/components/PainelGrafico.vue';

export default {
    name: 'OtifGeral',
    components: { PainelGrafico },
    props: {
        mes: { required: true },
        ano: { required: true },
        motivoIndisponivel: {
            type: String,
            default: 'Indicador OTIF depende de In Full — dados ainda não disponíveis',
        },
    },
    emits: ['updateMes'],
    data() {
        return {
            meta: 95,
            mostrarGrafico: true,
        };
    },
};
</script>
